import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

interface IFiNumericValidatorResult {
    notNumeric?: boolean;
}

@Directive({
    selector: '[fiNumericValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: FiNumericValidatorDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiNumericValidatorDirective implements Validator {
    validate(control: AbstractControl): IFiNumericValidatorResult {
        if (control.value && !control.value.match(/^\d+$/))
            return {
                notNumeric: true,
            };

        // this._control = control;
        // if (control.value && control.value !== this.currentValue) {
        //     return { equalto: true };
        // };

        return null;
    }
}
